<template>
  <footer class="footer-panel">
    <div class="footer-grid">
      <section>
        <p class="footer-heading">Selección nocturna</p>
        <h2 class="footer-brand">Fomo Planes</h2>
        <p class="footer-copy">
          Hay dos clases de planes: los que están en FOMO y los demás; entra a los eventos, conciertos, fiestas y experiencias que todos quieren vivir.
        </p>
        <div class="footer-social">
          <a href="https://www.instagram.com/fomoplanes/" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
          <a href="https://www.facebook.com/fomoplanes/" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="https://www.tiktok.com/@fomoplanes" aria-label="TikTok"><i class="fab fa-tiktok"></i></a>
          <a href="mailto:fomoplanes@sudenec.com" aria-label="Email"><i class="fa fa-envelope"></i></a>
        </div>
      </section>

      <section>
        <p class="footer-heading">Explora</p>
        <div class="footer-links">
          <router-link :to="{ name: 'home' }">Eventos destacados</router-link>
          <router-link :to="{ name: 'launch-event' }">Lanza tu evento</router-link>
          <router-link :to="{ name: 'swap-landing' }">Vender entradas</router-link>
          <router-link :to="{ name: 'usertickets' }">Mis tickets</router-link>
          <router-link :to="{ name: 'company' }">Compania</router-link>
          <a href="/organizadores/">FOMO para organizadores</a>
          <a href="/organizadores/ecuador/">Ticketeras en Ecuador</a>
          <a href="/organizadores/argentina/">Ticketeras en Argentina</a>
          <a href="/organizadores/panama/">Ticketeras en Panamá</a>
          <a href="/foros/">Foros y comparativas</a>
        </div>
      </section>

      <section>
        <p class="footer-heading">Legal y soporte</p>
        <div class="footer-links">
          <router-link :to="{ name: 'terms' }">Terminos y condiciones</router-link>
          <router-link :to="{ name: 'privacy' }">Politica de privacidad</router-link>
          <router-link :to="{ name: 'refunds' }">Reembolsos y cancelaciones</router-link>
          <router-link :to="{ name: 'contact' }">Contacto</router-link>
          <a href="mailto:fomoplanes@sudenec.com">fomoplanes@sudenec.com</a>
        </div>
      </section>
    </div>

    <div class="footer-bottom">
      <p class="footer-legal">Fear of Missing Out</p>
      <p class="footer-legal">FOMOPLANES es operado por GINGO ENTERPRISES LLC. Fomo Planes © 2026</p>
    </div>

    <p class="footer-address footer-legal">Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos.</p>
  </footer>
</template>

<script>
export default {
  name: 'FooterMain',
}
</script>

<style scoped>
.footer-copy,
.footer-legal {
  margin: 0;
  line-height: 1.7;
}

.footer-copy,
.footer-legal {
  color: var(--text-soft);
}

.footer-address {
  margin-top: 10px;
  text-align: right;
}

@media (max-width: 900px) {
  .footer-bottom {
    flex-direction: column;
  }

  .footer-address {
    text-align: left;
  }
}
</style>
